import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

export type SalesMeasure = "revenue" | "count" | "aov";

export interface SalesMonthRow {
  monthLabel: string;
  monthNumber: number;
  selected: number;
  previous: number;
  variancePct: number | null;
}

export interface SalesByMonthResponse {
  fy: number;
  fyLabel: string;
  previousFy: number;
  previousFyLabel: string;
  measure: SalesMeasure;
  months: SalesMonthRow[];
  totals: { selected: number; previous: number; variancePct: number | null };
}

export interface SalesInvoiceRowDto {
  invoiceId: number;
  invoiceReferenceNo: string;
  invoiceDate: string | null;
  clientName: string | null;
  totalIncGst: number;
  status: string;
}

function qs(params: Record<string, string | number | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== "") sp.set(k, String(v));
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export const salesReportApi = {
  monthly: (fy?: number, measure: SalesMeasure = "revenue") =>
    apiFetch<SalesByMonthResponse>(`/api/reports/sales-by-month${qs({ fy, measure })}`),
  drilldown: (fy: number, month: number, page = 1) =>
    apiFetch<PagedResult<SalesInvoiceRowDto>>(`/api/reports/sales-by-month/drilldown${qs({ fy, month, page })}`),
  csvUrl: (fy: number, measure: SalesMeasure) => `/api/reports/sales-by-month/export.csv${qs({ fy, measure })}`,
};
